import React from 'react'
import Routing from '../routing/Routing'
import './WorkArea.css'

export default function WorkArea() {
  return (
    <div className='workArea'>
      <Routing />
    </div>
  )
}
